module.exports = __webpack_public_path__ + "img/sodam_thum05.54d92cb0.jpg";